"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.floatToInt = floatToInt;
exports.saveParseInt = saveParseInt;
exports.valBetween = valBetween;
function floatToInt(input) {
  var parsed = parseFloat(input, 10);
  return isNaN(parsed) ? 0 : Math.trunc(parsed);
}
function saveParseInt(str) {
  var parsed = parseInt(str, 10);
  // eslint-disable-next-line no-restricted-globals
  return isNaN(parsed) ? null : parsed;
}
function valBetween(v, min, max) {
  return Math.min(max, Math.max(min, v));
}